import { useLayoutEffect, useRef, useState } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Desktop, Mobile } from '../../App';
import { TextWithTooltip } from '../../components/common/TextWithTooltip';
import {
  BV,
  PO,
  UV,
  calculatePercentage,
  formatUSDNoDecimals,
  formatVP
} from '../../helpers/helperFunctions';
import { BIG_WHALE, ENTRY_PACKAGE, RANKING } from '../../routes/routes';
import {
  CaptionText,
  H1,
  H3,
  H4,
  H5,
  P1,
  P2,
  P3
} from '../../styles/FontStyles';
import {
  Flexed,
  ProgressBarWithPercentage
} from '../../styles/GlobalComponents';
import { color, colors } from '../../styles/GlobalStyles';

import {
  PackageRankMyProgressModel,
  PackageRankSelectedRewardModel
} from './Ranking.types';
import { MavieRank, RankImage, RankStatus } from './RankingStyled';
import { QualifiedPartner } from './QualifiedPartner';
import { Button } from '../../components';

export const RankComponent = ({
  rank,
  handleClaim,
  isDashboard = false
}: {
  rank: PackageRankMyProgressModel;
  handleClaim?: (rank: PackageRankMyProgressModel) => void;
  isDashboard?: boolean;
}) => {
  const history = useHistory();
  const { t } = useTranslation('ranking');

  const ref = useRef<any | null>(null);
  const refChild = useRef<any | null>(null);

  const ref2 = useRef<any | null>(null);
  const refChild2 = useRef<any | null>(null);

  const ref3 = useRef<any | null>(null);
  const refChild3 = useRef<any | null>(null);

  const ref4 = useRef<any | null>(null);
  const refChild4 = useRef<any | null>(null);

  const [width, setWidth] = useState(0);
  const [widthChild, setWidthChild] = useState(0);

  const [width2, setWidth2] = useState(0);
  const [widthChild2, setWidthChild2] = useState(0);

  const [width3, setWidth3] = useState(0);
  const [widthChild3, setWidthChild3] = useState(0);

  const [width4, setWidth4] = useState(0);
  const [widthChild4, setWidthChild4] = useState(0);

  useLayoutEffect(() => {
    if (ref.current && ref2.current && ref3.current && ref4.current) {
      setWidth(ref.current.clientWidth);
      setWidthChild(refChild.current.clientWidth);

      setWidth2(ref2.current.clientWidth);
      setWidthChild2(refChild2.current.clientWidth);

      setWidth3(ref3.current.clientWidth);
      setWidthChild3(refChild3.current.clientWidth);

      setWidth4(ref4.current.clientWidth);
      setWidthChild4(refChild4.current.clientWidth);
    }
  }, [ref]);

  return (
    <MavieRank
      isNext={rank.isFutureRank}
      id={rank.name}
      style={{ cursor: isDashboard ? 'pointer' : 'default' }}
      onClick={() => isDashboard && history.push(RANKING)}>
      <RankImage
        image={rank.imageUrl}
        isDisabled={!isDashboard && !rank.isRankStatusActive}>
        <Desktop>
          <H3 color={color.colors.neutral0} style={{ fontFamily: 'Nulshock' }}>
            {rank.name}
          </H3>
        </Desktop>
        <Mobile>
          <H4 color={color.colors.neutral0} style={{ fontFamily: 'Nulshock' }}>
            {rank.name}
          </H4>
        </Mobile>

        <RankStatus>
          {rank.rewards?.map(
            (reward: PackageRankSelectedRewardModel, i: number) => {
              return (
                <Flexed alignEnd key={i} gap='5px'>
                  <CaptionText mb='3' color={color.colors.neutral50}>
                    RANK REWARD
                  </CaptionText>
                  <P1 bold color={color.colors.neutral50}>
                    {reward.reward.name}
                  </P1>
                </Flexed>
              );
            }
          )}
          {!isDashboard && (
            <Desktop>
              <Flexed column alignEnd>
                <Flexed gap='10px'>
                  {rank.shouldDisplayActivateRankStatus && (
                    <Button
                      w='200px'
                      mt='10'
                      onClick={() => history.push(ENTRY_PACKAGE)}
                      style={{ fontFamily: 'Nulshock' }}>
                      ACTIVATE RANK
                    </Button>
                  )}
                  {rank.rewards.length > 0 &&
                    (rank.name !== 'Qualified Partner' ? (
                      <Flexed>
                        <Button
                          negative
                          w='200px'
                          mt='10'
                          disabled
                          // disabled={!rank.canClaimReward}
                          onClick={() => handleClaim?.(rank)}
                          style={{ fontFamily: 'Nulshock' }}>
                          {rank.isRewardAlreadyClaimed
                            ? 'REWARD CLAIMED'
                            : 'CLAIM REWARD'}
                        </Button>
                      </Flexed>
                    ) : null)}
                </Flexed>
              </Flexed>
            </Desktop>
          )}
        </RankStatus>
      </RankImage>
      <div>
        <Flexed center between mb='10' rowSM alignStartSM>
          {!isDashboard && (
            <Flexed
              center
              gap='20px 80px'
              rowSM
              alignStartSM
              gapSM='20px'
              wrap
              between>
              <div>
                <CaptionText color={color.colors.neutral500} caps>
                  {t('binary_weekly_cap')}
                </CaptionText>
                <P2 bold>
                  {formatUSDNoDecimals(rank.weekCapRuleLimit)} USDT /{' '}
                  {t('week')}
                </P2>
              </div>
            </Flexed>
          )}
        </Flexed>

        <QualifiedPartner rank={rank} />

        {rank.name !== 'Qualified Partner' && (
          <>
            <Flexed center between mb='8' gap='8px'>
              <CaptionText color={color.colors.neutral700} semiBold>
                {t('weak_team')}
              </CaptionText>

              <CaptionText right color={color.colors.neutral700}>
                {t('required')}: {formatVP(rank.paidTeamLimit)} {BV}
              </CaptionText>
            </Flexed>

            <ProgressBarWithPercentage
              progressWidth={width}
              progressValueWidth={widthChild}
              percentage={calculatePercentage(
                rank.paidTeamCurrent,
                rank.paidTeamLimit
              )}
              color={
                calculatePercentage(rank.paidTeamCurrent, rank.paidTeamLimit) >
                99
                  ? color.colors.success500
                  : color.colors.warning
              }>
              <div ref={ref}>
                <div ref={refChild}>
                  {rank.paidTeamCurrent === rank.paidTeamLimit
                    ? t('done')
                    : `${formatVP(rank.paidTeamCurrent)} ${BV}`}
                </div>
              </div>
            </ProgressBarWithPercentage>

            <Flexed center between gap='8px' mb='8'>
              <TextWithTooltip
                margin='0'
                tooltip={
                  <Flexed width='200px'>
                    {t('what_is_rule')}
                    <br />
                    <br />
                    {t('this_rule_applies')}
                  </Flexed>
                }>
                <CaptionText
                  color={color.colors.neutral700}
                  semiBold
                  style={{ display: 'inline' }}>
                  40 / 40 / 20 {t('direct_volume')}
                </CaptionText>
              </TextWithTooltip>
              <CaptionText right color={color.colors.neutral700}>
                {t('required')}: {formatVP(rank.directVolumeLimit)} {UV}
              </CaptionText>
            </Flexed>
            <ProgressBarWithPercentage
              progressWidth={width2}
              progressValueWidth={widthChild2}
              amount={rank.directVolumeCurrent}
              percentage={calculatePercentage(
                rank.directVolumeCurrent,
                rank.directVolumeLimit
              )}
              color={
                calculatePercentage(
                  rank.directVolumeCurrent,
                  rank.directVolumeLimit
                ) > 99
                  ? color.colors.success500
                  : color.colors.warning
              }>
              <div ref={ref2}>
                <div ref={refChild2}>
                  {rank.directVolumeCurrent === rank.directVolumeLimit
                    ? t('done')
                    : `${formatVP(rank.directVolumeCurrent)} ${UV}`}
                </div>
              </div>
            </ProgressBarWithPercentage>

            <Flexed center between gap='8px' mb='8'>
              <CaptionText color={color.colors.neutral700} semiBold>
                20% {t('in_strong_team')}
              </CaptionText>
              <CaptionText right color={color.colors.neutral700}>
                {t('required')}: {formatVP(rank.strongTeamLimit)} {UV}
              </CaptionText>
            </Flexed>
            <ProgressBarWithPercentage
              progressWidth={width3}
              progressValueWidth={widthChild3}
              amount={rank.strongTeamCurrent}
              percentage={calculatePercentage(
                rank.strongTeamCurrent,
                rank.strongTeamLimit
              )}
              color={
                calculatePercentage(
                  rank.strongTeamCurrent,
                  rank.strongTeamLimit
                ) > 99
                  ? color.colors.success500
                  : color.colors.warning
              }>
              <div ref={ref3}>
                <div ref={refChild3}>
                  {rank.strongTeamCurrent === rank.strongTeamLimit
                    ? t('done')
                    : `${formatVP(rank.strongTeamCurrent)} ${UV}`}
                </div>
              </div>
            </ProgressBarWithPercentage>

            <Flexed center between gap='8px' mb='8'>
              <CaptionText color={color.colors.neutral700} semiBold>
                Personal Orders
              </CaptionText>

              <CaptionText right color={color.colors.neutral700}>
                {t('required')}: {formatVP(rank.personalOrderLimit)} {PO}
              </CaptionText>
            </Flexed>
            <ProgressBarWithPercentage
              progressWidth={width4}
              progressValueWidth={widthChild4}
              amount={rank.personalOrderAmount}
              percentage={calculatePercentage(
                rank.personalOrderAmount,
                rank.personalOrderLimit
              )}
              color={
                calculatePercentage(
                  rank.personalOrderAmount,
                  rank.personalOrderLimit
                ) > 99
                  ? color.colors.success500
                  : color.colors.warning
              }>
              <div ref={ref4}>
                <div ref={refChild4}>
                  {rank.personalOrderAmount === rank.personalOrderLimit
                    ? t('done')
                    : `${formatVP(rank.personalOrderAmount)} ${PO}`}
                </div>
              </div>
            </ProgressBarWithPercentage>
          </>
        )}

        {!isDashboard && (
          <Mobile>
            {rank.rewards.length > 0 && rank.name !== 'Qualified Partner' && (
              <Button
                negative
                w='100%'
                mt='10'
                disabled
                // disabled={!rank.canClaimReward}
                onClick={() => handleClaim?.(rank)}
                style={{ fontFamily: 'Nulshock' }}>
                {rank.isRewardAlreadyClaimed
                  ? 'REWARD CLAIMED'
                  : 'CLAIM REWARD'}
              </Button>
            )}

            {rank.shouldDisplayActivateRankStatus && (
              <Button
                w='200px'
                mt='10'
                onClick={() => history.push(ENTRY_PACKAGE)}
                style={{ fontFamily: 'Nulshock' }}>
                ACTIVATE RANK
              </Button>
            )}
          </Mobile>
        )}
      </div>
    </MavieRank>
  );
};
